export enum AgreementStatusEnum {
  DRAFT = 'DRAFT',
  CANCELED = 'CANCELED',
  READY_TO_APPROVE = 'READY_TO_APPROVE',
  ON_APPROVAL = 'ON_APPROVAL',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  TERMINATED = 'TERMINATED',
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED',
  PENDING_TERMINATION = 'PENDING_TERMINATION',
}
